import { runDemo } from "../shared/demoRunner";
import { createInstancesScene } from "./scene";

runDemo({ createScene: createInstancesScene });
